import { apiClient } from './client';

export interface AdminStats {
  patients: number;
  users: number;
  visits_today: number;
}

export async function getAdminStats(): Promise<AdminStats> {
  const response = await apiClient.get<AdminStats>('/admin/stats');
  return response.data;
}